import { isCancel } from "axios";

export const isCanceledRequestError = (error: unknown): boolean => {
  if (isCancel(error)) {
    return true;
  }

  return (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    error.name === "AbortError"
  );
};
